"use strict";

import Isotope from "isotope-layout";
require("isotope-packery");
import imagesLoaded from "imagesloaded";
import Dropdown from "./class-dropdown.js";
import helper from "./helper.js";


  const Projects = {
    iso: null,

    setFilterAccent: function (filterName) {
      document.body.classList.toggle(
        "is-filter-investments",
        filterName === "investments"
      );
    },

    setup_dropdowns: function () {
      window.all_dropdowns = [];
      document.querySelectorAll(".dropdown").forEach(function (dropdown) {
        window.all_dropdowns.push(new Dropdown(dropdown));
      });
      this.dropdowns = window.all_dropdowns;
    },

    setup_filters: function () {
      var self = this;
      this.setup_dropdowns();

      var grid = this.iso;

      this.filter("development", ".co-developer");
      this.filter(
        "construction",
        ".general-contractor:not(.co-developer):not(.developer)"
      );
      this.filter("investments", ".investments");
      this.filter("clear-all", "*", "");

      document
        .querySelectorAll(".type.dropdown .inner button")
        .forEach(function (btn) {
          var type = btn.getAttribute("data-type");
          var buttonGroup = document.querySelector(".button-group." + type);
          btn.addEventListener("click", function () {
            document.querySelectorAll(".button-group").forEach(function (group) {
              group.classList.remove("active");
            });
            buttonGroup.classList.add("active");
            var subFilters = document.querySelector(".sub-filters");
            if (document.querySelectorAll(".button-group." + type + " button").length) {
              subFilters.classList.add("active");
            } else {
              subFilters.classList.remove("active");
            }
          });
        });

      document.querySelectorAll(".project-grid-header button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (
            btn.closest(".type.dropdown") !== null ||
            btn.closest(".sub-filters") !== null
          ) {
            return;
          }
          document.querySelector(".sub-filters").classList.remove("active");
        });
      });

      document.querySelectorAll(".dropdown .inner button").forEach(function (btn) {
        var className = btn.getAttribute("class");
        self.filter(className, "." + className);
      });

      document.querySelectorAll(".button-group button").forEach(function (btn) {
        var className = btn.getAttribute("class");
        self.filter(className, "." + className);
      });

      document.querySelector(".filters .shuffle").addEventListener("click", () => {
        grid.shuffle();
      });
    },

    init_filter: function () {
      let searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has("filter")) {
        var className = searchParams.get("filter");
        var btn = document.querySelector("." + className);
        if (btn) {
          btn.click();
        } else {
          Projects.setFilterAccent(className);
          this.add_items();
        }
      } else {
        Projects.setFilterAccent(null);
        this.add_items();
      }
    },

    clear_grid: function () {
      var elems = this.iso.getItemElements();
      this.page = 0;

      elems.forEach(function (el) {
        Projects.iso.remove(el);
      });
    },

    add_portfolio_item: function (data) {
      var template = document.createElement("a");
      template.draggable = false;
      template.classList.add(...data.classes.split(" "));
      template.href = data.url;
      var image = document.createElement("img");
      image.classList.add("project-preview-image");
      image.draggable = false;
      image.setAttribute("style", data.style);
      image.src = data.image;
      image.alt = data.image_alt;
      template.appendChild(image);

      var footer = document.createElement("footer");
      footer.classList.add("project-preview-meta");
      var p = document.createElement("p");
      p.classList.add("sans-serif-small");
      var name = document.createElement("strong");
      name.textContent = data.title;
      p.appendChild(name);
      if (data.location) {
        var span = document.createElement("span");
        span.textContent = "|";
        p.appendChild(span);
        p.appendChild(document.createTextNode(data.location));
      }
      footer.appendChild(p);
      template.appendChild(footer);
      this.iso.insert(template);
    },

    add_cta_item: function () {
      var constructionCta = document.createElement("a");
      constructionCta.classList.add(
        "project-preview-item",
        "placeholder",
        "horizontal",
        "general-contractor"
      );
      constructionCta.draggable = false;
      constructionCta.href = "/construction/";
      constructionCta.innerHTML =
        '<div class="content"> <div class="sans-serif-huge">Learn about Construction:</div> <div class="sans-serif-normal">Explore our unique Sightlines processes.</div> </div>';

      var developerCta = document.createElement("a");
      developerCta.classList.add(
        "project-preview-item",
        "placeholder",
        "horizontal",
        "co-developer"
      );
      developerCta.draggable = false;
      developerCta.href = "/development/";
      developerCta.innerHTML =
        ' <div class="content"> <div class="sans-serif-huge">Learn about Development:</div> <div class="sans-serif-normal">Review our competencies and experience.</div> </div>';

      var investmentsCta = document.createElement("a");
      investmentsCta.classList.add(
        "project-preview-item",
        "placeholder",
        "horizontal",
        "investments"
      );
      investmentsCta.draggable = false;
      investmentsCta.href = "/investments/";
      investmentsCta.innerHTML =
        '<div class="content"> <div class="sans-serif-huge">Learn about Investments:</div> <div class="sans-serif-normal">Discover our equity and debt capabilities.</div> </div>';

      if (!this.has_construction) {
        this.iso.insert(constructionCta);
        this.has_construction = true;
      }
      if (!this.has_development) {
        this.iso.insert(developerCta);
        this.has_development = true;
      }
      if (!this.has_investments) {
        this.iso.insert(investmentsCta);
        this.has_investments = true;
      }
    },

    add_item: function (data) {
      console.log('adding item', data);
      if (data.type === "project") {
        this.add_portfolio_item(data);
      }
      if (data.type === "cta") {
        this.add_cta_item(data);
      }
    },

    add_items: function () {
      document.querySelector(".loading").style.display = "block";
      document.querySelector(".load-more-button").style.display = "none";

      console.log('running add_items');

      var xhr = new XMLHttpRequest();
      var offset = this.page;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let filter = ''
      if (urlParams.has("filter")) {
        filter = '&filter=' + urlParams.get("filter")
      }

      xhr.open("GET", this.nextURL + '?page=' + offset + filter, true);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);

            console.log('returned data', data);

            data.data.splice(
              3,
              0,
              {
                type: "cta",
              }
            );
            data.data.splice(
              4,
              0,
              {
                type: "cta",
              }
            );

            for (var item of data.data) {
              this.add_item(item);
            }

            if (data.data.length >= 16) {
              this.page++;
              document.querySelector(".load-more-button").style.display = "block";
              document.querySelector(".loading").style.display = "none";
            } else {
              this.page = 0;
              offset = 0;
              document.querySelector(".loading").style.display = "none";
              document.querySelector(".load-more-button").style.display = "none";
            }

            helper.fix_page_height();
          } else {
            console.log('error: ', xhr.status);
          }
          helper.fix_page_height();
        }
      };
      xhr.send();
    },

    filter: function (button, selector) {
      document.querySelectorAll("." + button).forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          var queryString = "?filter=" + button;
          var activeBtns = document.querySelectorAll("button.active");
          activeBtns.forEach(function (activeBtn) {
            activeBtn.classList.remove("active");
          });
          Projects.clear_grid();

          if (button === "clear-all") {
            document.querySelector(".active-filters").classList.remove("active");
            document.querySelector(".clear-all").classList.remove("active");

            history.pushState({}, "", window.location.pathname);
            this.nextURL = "/portfolio.json";
            this.has_construction = false;
            this.has_development = false;
            this.has_investments = false;
            Projects.setFilterAccent(null);
          } else {
            document.querySelector(".active-filters").classList.add("active");
            document.querySelector(".clear-all").classList.add("active");

            btn.classList.add("active");
            var activeFilters = document.querySelector(".active-filters");
            var span = document.createElement("span");
            span.textContent = btn.getAttribute("data-message");
            activeFilters.innerHTML = "";
            activeFilters.appendChild(span);

            history.pushState({}, "", queryString);
            this.nextURL = btn.getAttribute("data-query");
            this.has_construction = false;
            this.has_development = false;
            this.has_investments = false;
            Projects.setFilterAccent(button);
          }
          Projects.add_items();
        });
      });
    },

    

    init: function () {
      this.nextURL = "/portfolio.json";
      this.page = 0;
      this.has_construction = false;
      this.has_development = false;
      this.has_investments = false;
      this.iso = new Isotope(".project-grid", {
        itemSelector: ".project-preview-item",
        percentPosition: true,
        layoutMode: "packery",
        packery: {
          gutter: ".project-preview-gutter",
        },
      });
      this.setup_filters();
      this.init_filter(); // looks for URL params to start the search
      imagesLoaded(".project-grid").on("progress", function () {
        this.iso.layout();
      });
      this.iso.on("arrangeComplete", () => {
        helper.fix_page_height();
      });
      document.querySelector(".load-more-button").addEventListener("click", () => {
        this.add_items();
      });
      window.addEventListener("resize", () => {
        this.iso.layout();
      });
    },
  };

  Projects.init();
